import * as React from "react";
import { Grid } from "./Table.styles";
import { TipPosition } from "./useTooltips";

export const MemoCell = React.memo(
  (props: {
    k: string;
    v: any;
    tableIsSmall: boolean;
    alignLeft: boolean;
    subData?: any;
    tooltip?: string;
    setRefs: React.Dispatch<React.SetStateAction<{ [row: number]: HTMLDivElement[]; }>>;
    className?: string;
    showTip: (key: string, message: string, target: HTMLElement, position: TipPosition) => void,
    hideTip: (key: string) => void;
    handleHighlightMouseOver: (rowNumber: number) => void;
    handleHighlightMouseOut: (rowNumber: number) => void;
    rowNumber:number;
  }) => {
    return (
      <Grid.Cell
        alignLeft={props.alignLeft}
        tableIsSmall={props.tableIsSmall}
        key={props.k}
        className={props.className}
        ref={(ref: HTMLDivElement) => {
          props.setRefs(prev => ({
            ...prev,
            [props.rowNumber]: [
              // clear out old/bad refs from this row
              ...(prev[props.rowNumber] || []).filter(elem => !!elem && elem?.offsetHeight > 0),
              // add new ref 
              ref
            ]
          }))
        }}
        onMouseEnter={event => {
          let target = event.target as HTMLElement;
          target = (target.closest(".cell") as HTMLElement) || target;
          props.handleHighlightMouseOver(props.rowNumber)
          props.showTip(props.k, props.tooltip, target, "horizontal");
        }}
        onMouseLeave={() => {
          props.hideTip(props.k)
          props.handleHighlightMouseOut(props.rowNumber)
        }}
      >
        <div className="data">{props.v}</div>
        {Array.isArray(props.subData) &&
          props.subData.map((data, index) => {
            return <div key={index} className="subdata">{data}</div>;
          })}
        {typeof props.subData === "string" && <div className="subdata">{props.subData}</div>}
      </Grid.Cell>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.k === nextProps.k;
  }
);

export const MemoRowHeader = React.memo(
  (props: {
    k: string;
    v: any;
    tableIsSmall: boolean;
    alignLeft: boolean;
    subData?: any;
    tooltip?: string;
    notSortable?: boolean,
    setRefs: React.Dispatch<React.SetStateAction<{ [row: number]: HTMLDivElement[]; }>>;
    className?: string;
    showTip: (key: string, message: string, target: HTMLElement, position: TipPosition) => void,
    hideTip: (key: string) => void;
    handleHighlightMouseOver: (rowNumber: number) => void;
    handleHighlightMouseOut: (rowNumber: number) => void;
    rowNumber:number;
  }) => {

    React.useEffect(() => {
      // on component will unmount
      return () => {
        props.hideTip(props.k);
      }
    }, []);

    return (
      <Grid.RowHeader
        notSortable={props.notSortable}
        tableIsSmall={props.tableIsSmall}
        alignLeft={props.alignLeft}
        key={props.k}
        ref={(ref: HTMLDivElement) => {
          props.setRefs(prev => ({
            ...prev,
            [props.rowNumber]: [
              ...(prev[props.rowNumber] || []).filter(elem => !!elem && elem?.offsetHeight > 0),
              ref
            ]
          }))
        }}
        className={props.className}
        onMouseEnter={event => {
          let target = event.target as HTMLElement;
          props.handleHighlightMouseOver(props.rowNumber)
          target = (target.closest(".row-header") as HTMLElement) || target;
          props.showTip(props.k, props.tooltip, target, "horizontal");
        }}
        onMouseLeave={() => {
          props.hideTip(props.k)
          props.handleHighlightMouseOut(props.rowNumber)
        }
      }
      >
        <div className="data">{props.v}</div>
        {Array.isArray(props.subData) &&
          props.subData.map((data, index) => {
            return (
              <div key={index} className="subdata">
                {data}
              </div>
            );
          })}
        {typeof props.subData === "string" && <div className="subdata">{props.subData}</div>}
      </Grid.RowHeader>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.k === nextProps.k;
  }
);

